
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joint-hip-and-knee-replacement",
      function () {
        return require("private-next-pages/joint-hip-and-knee-replacement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joint-hip-and-knee-replacement"])
      });
    }
  